import React, { createContext, useContext, useState, useEffect } from 'react';
import { he } from './he';
import { en } from './en';

const translations = { he, en };

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('mart-language');
    return saved || 'he';
  });

  // Apply RTL/LTR on mount and language change
  useEffect(() => {
    localStorage.setItem('mart-language', language);
    
    // Force RTL/LTR on html element
    const html = document.documentElement;
    html.setAttribute('dir', language === 'he' ? 'rtl' : 'ltr');
    html.setAttribute('lang', language);
    
    // Also set on body for extra safety
    document.body.setAttribute('dir', language === 'he' ? 'rtl' : 'ltr');
    document.body.style.direction = language === 'he' ? 'rtl' : 'ltr';
    document.body.style.textAlign = language === 'he' ? 'right' : 'left';
  }, [language]);

  // Re-apply on every render to catch navigation changes
  useEffect(() => {
    const applyDirection = () => {
      const dir = language === 'he' ? 'rtl' : 'ltr';
      document.documentElement.setAttribute('dir', dir);
      document.documentElement.setAttribute('lang', language);
      document.body.setAttribute('dir', dir);
    };
    
    applyDirection();
    
    // Also apply after a short delay to catch any late DOM updates
    const timeout = setTimeout(applyDirection, 100);
    return () => clearTimeout(timeout);
  });

  const t = translations[language];
  
  const toggleLanguage = () => {
    setLanguage(prev => prev === 'he' ? 'en' : 'he');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
